import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth.tsx'
import { SuspenseLoader } from './SuspenseLoader.tsx'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredRole?: string
}

export function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { user, loading } = useAuth()

  if (loading) return <SuspenseLoader />
  if (!user) return <Navigate to="/admin/login" replace />
  if (requiredRole && user.role !== requiredRole) return <Navigate to="/admin" replace />

  return <>{children}</>
}
